<template>
  <div class="page-container">
    <el-tabs v-model="activeName">
      <el-tab-pane label="管理端用户权限设置" name="auth">
        <el-card class="page-content">
          <el-table :data="adminUserList">
            <el-table-column prop="id" v-if="false"></el-table-column>
            <el-table-column prop="userId" label="用户ID"></el-table-column>
            <el-table-column label="用户账号" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.tel">{{ scope.row.tel }}</span>
                <span v-if="!scope.row.tel">{{ scope.row.email }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="realName"
                label="用户名"
                align="center"
            ></el-table-column>
            <el-table-column label="角色" align="center">
              <template slot-scope="scope">{{
                  parseCodeToDesc(scope.row.role, roleType)
                }}
              </template>
            </el-table-column>
            <el-table-column
                prop="authType"
                label="权限信息"
                :show-overflow-tooltip="true"
                align="center"
            ></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                    type="primary"
                    icon="el-icon-edit"
                    circle
                    @click="openDialog(scope.row.id, scope.row.authType)"
                ></el-button>
                <el-button
                    type="warning"
                    circle
                    @click="resetAuth(scope.row.id, scope.row.authType)"
                >
                  重置
                </el-button>
                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click="removeAdminUser(scope.row.id)"
                ></el-button>
                <el-button
                    type="success"
                    circle
                    @click="openAlterRole(scope.row)"
                >
                  角色修改
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="二次验证口令设置" name="passphrase">
        <el-form :inline="true">
          <el-form-item label="验证类型">
            <el-select v-model="verifyType">
              <el-option
                  v-for="item in verifyTypes"
                  :key="item.code"
                  :label="item.desc"
                  :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryConfig()">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="passphraseSubmit()"
            >口令设置提交
            </el-button
            >
          </el-form-item>
        </el-form>
        <el-form v-model="passphraseConf" label-width="150px">
          <el-form-item label="生效的口令类型">
            <el-select v-model="passphraseConf.effectType">
              <el-option
                  v-for="item in ruleType"
                  :key="item.code"
                  :label="item.desc"
                  :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-row>
            <el-col :span="5">
              <el-form-item label="时间规则："></el-form-item>
              <el-form-item label="天数偏移量">
                <el-input-number
                    v-model="passphraseConf.dayOffset"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="月偏移量">
                <el-input-number
                    v-model="passphraseConf.monthOffset"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="年偏移量">
                <el-input-number
                    v-model="passphraseConf.yearOffset"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="用户名规则："></el-form-item>
              <el-form-item label="截取开始索引">
                <el-input-number
                    v-model="passphraseConf.startIndex"
                    :min="0"
                    :max="6"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="截取结束索引">
                <el-input-number
                    v-model="passphraseConf.endIndex"
                    :min="0"
                    :max="10"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="固定字符规则："></el-form-item>
              <el-form-item label="固定口令">
                <el-input v-model="passphraseConf.fixedCharacter"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="管理端用户新增" name="creat-admin-user">
        <el-form label-width="180px">
          <el-form-item label="用户名：(手机/邮箱)">
            <el-input v-model="username" style="width: 265px;"></el-input>
          </el-form-item>
          <el-form-item label="角色：">
            <el-select v-model="role">
              <el-option
                  v-for="item in roleType"
                  :label="item.desc"
                  :key="item.code"
                  :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="createAdminUser()"
            >确认新增为管理端用户
            </el-button
            >
          </el-form-item>
        </el-form>

        <el-form>
          <el-form-item>
            <el-button type="primary" @click="syncAdminInfo()"
            >同步admin_user表中的数据（针对老数据中无userId和active值的情况）
            </el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="权限编辑" :visible="dialogShow" @close="closeHandle()">
      <el-checkbox-group v-model="authList">
        <!--        <el-tag size="small">风控系统</el-tag>-->
        <!--         <div style="height: 10px;" />-->
        <!--        <el-checkbox label="270001" class="item-one">风控系统</el-checkbox>-->
        <div style="height: 10px;"/>
        <el-tag size="small">用户系统</el-tag>
        <div style="height: 10px;"/>
        <el-checkbox label="10100" class="item-one">KYC认证审批</el-checkbox>
        <el-checkbox label="10101" class="item">KYC认证审批查询</el-checkbox>
        <!--        <el-checkbox label="10102" class="item">KYC基础配置</el-checkbox>-->
        <!--        <el-checkbox label="10103" class="item">登录注册实名开关</el-checkbox>-->
        <el-checkbox label="10200" class="item">用户身份信息</el-checkbox>
        <el-checkbox label="10202" class="item">用户身份信息修改</el-checkbox>
        <el-checkbox label="10207" class="item">用户身份信息查询</el-checkbox>

        <el-checkbox label="10203" class="item">用户标签信息</el-checkbox>
        <el-checkbox label="10204" class="item">用户标签信息删除</el-checkbox>
        <el-checkbox label="10205" class="item">用户冻结</el-checkbox>
        <el-checkbox label="10206" class="item">用户解冻</el-checkbox>

        <el-checkbox label="10215" class="item">子账号信息</el-checkbox>
        <el-checkbox label="10210" class="item">子账号查询</el-checkbox>

<!--        <el-checkbox label="10300" class="item">项目方管理</el-checkbox>-->
<!--        <el-checkbox label="10301" class="item">项目方余额信息</el-checkbox>-->
<!--        <el-checkbox label="10302" class="item">项目方管理删除</el-checkbox>-->

        <el-checkbox label="10400" class="item">商户设置</el-checkbox>
        <!--        <el-checkbox label="10500" class="item">部落资料审批</el-checkbox>-->
        <!--        <el-checkbox label="10700" class="item">登陆用户工单</el-checkbox>-->
        <!--        <el-checkbox label="10701" class="item">未登录用户工单</el-checkbox>-->
        <el-checkbox label="10900" class="item">用户余额快照</el-checkbox>
        <el-checkbox label="80303" class="item">用户分组</el-checkbox>
        <!--        <el-checkbox label="140001" class="item">运营人员工单</el-checkbox>-->
        <!--        <el-checkbox label="140002" class="item">研发人员工单</el-checkbox>-->

        <el-checkbox label="999998" class="item">权限查询</el-checkbox>

        <div style="height: 10px;"/>
        <el-tag size="small">充提系统</el-tag>
        <div style="height: 10px;"/>
        <el-checkbox label="20100" class="item-one">充值审核</el-checkbox>
        <el-checkbox label="20308" class="item-one">设置提现手续费</el-checkbox>
        <el-checkbox label="20101" class="item">充值审核查询</el-checkbox>
        <el-checkbox label="20102" class="item">大额充值复审</el-checkbox>
        <el-checkbox label="20103" class="item">手工录入充值</el-checkbox>
        <el-checkbox label="20104" class="item">入账审核配置</el-checkbox>
        <el-checkbox label="20105" class="item">入账人工审核</el-checkbox>
        <el-checkbox label="20106" class="item">充值内部状态变更</el-checkbox>
        <el-checkbox label="20107" class="item">充提限制</el-checkbox>
        <el-checkbox label="20200" class="item">提现审批</el-checkbox>
        <!--        <el-checkbox label="20305" class="item">提现过审配置</el-checkbox>-->
        <el-checkbox label="20201" class="item">提现审批查询</el-checkbox>
        <el-checkbox label="20202" class="item">二次提现审批</el-checkbox>
        <el-checkbox label="20203" class="item">TX录入</el-checkbox>
        <el-tooltip
            effect="light"
            content="二次审核对应的USDT价格阈值设置"
            placement="top"
        >
          <el-checkbox label="20204" class="item"
          >二次审核对应的USDT价格阈值设置
          </el-checkbox
          >
        </el-tooltip>
        <el-checkbox label="20205" class="item">站内提现审批</el-checkbox>
        <el-checkbox label="20300" class="item">币种设置</el-checkbox>
        <el-checkbox label="20301" class="item">币种介绍设置</el-checkbox>
        <el-checkbox label="20302" class="item">充提币提醒设置</el-checkbox>
        <el-checkbox label="20303" class="item">币种获取</el-checkbox>
        <!--        <el-checkbox label="20206" class="item">项目方资产汇总</el-checkbox>-->
        <!-- <el-checkbox label="" class="item">充值自动过审配置</el-checkbox> -->
        <el-checkbox label="20304" class="item">热门币种配置</el-checkbox>
        <!--         <el-checkbox label="20306" class="item">提币链信息提示</el-checkbox>-->

        <el-checkbox label="10201" class="item">用户充值地址信息</el-checkbox>
        <el-checkbox label="10208" class="item">用户充值地址信息查询</el-checkbox>
        <el-checkbox label="10209" class="item">用户提现地址信息查询</el-checkbox>
        <div style="height: 10px;"/>
        <el-tag size="small">财务系统</el-tag>
        <div style="height: 10px;"/>
        <el-checkbox label="30100" class="item-one"
        >Excel转账/钱包户、内部划转
        </el-checkbox
        >
        <el-checkbox label="250001" class="item">财务系统</el-checkbox>
        <el-checkbox label="30101" class="item">转账币种配置</el-checkbox>
        <el-checkbox label="30200" class="item">空投设置</el-checkbox>
<!--        <el-checkbox label="10802" class="item">批量归集白名单</el-checkbox>-->
<!--        <el-checkbox label="10803" class="item">提现白名单管理</el-checkbox>-->
        <el-checkbox label="30201" class="item">空投币种配置</el-checkbox>
        <el-checkbox label="30300" class="item">转账记录查询</el-checkbox>
        <!--        <el-checkbox label="30400" class="item"-->
        <!--          >市值账户转账记录查询</el-checkbox-->
        <!--        >-->
        <el-checkbox label="30500" class="item">对账查询</el-checkbox>
        <el-checkbox label="30501" class="item">对账配置</el-checkbox>
        <el-checkbox label="30502" class="item">手动对账</el-checkbox>
        <!--        <el-checkbox label="30503" class="item">钱包对账管理</el-checkbox>-->
        <!-- <el-checkbox label="30504" class="item">对冲对账明细</el-checkbox> -->
        <el-checkbox label="10600" class="item">用户账单</el-checkbox>
        <el-checkbox label="130001" class="item-one">资产统计</el-checkbox>

        <!--        <el-checkbox label="30505" class="item">PSI分红</el-checkbox>-->
        <!--        <el-checkbox label="30701" class="item">PSI分红结算</el-checkbox>-->
        <!--        <el-checkbox label="30700" class="item">燃烧币种分红</el-checkbox>-->
        <el-checkbox label="30506" class="item"
        >实时生成钱包余额快照
        </el-checkbox
        >

        <el-checkbox label="20230523" class="item"
        >资金明细
        </el-checkbox
        >

        <el-checkbox label="20230530" class="item"
        >用户对账查询
        </el-checkbox
        >

        <el-checkbox label="20230531" class="item"
        >平台对账查询
        </el-checkbox
        >

        <!--        <div style="height: 10px;" />-->
        <!--        <el-tag size="small">理财系统</el-tag>-->
        <!--        <div style="height: 10px;" />-->
        <!--        <el-checkbox label="40100" class="item-one">活期宝设置</el-checkbox>-->
        <!--        <el-checkbox label="40200" class="item">币存生息</el-checkbox>-->
        <!--        <el-checkbox label="40300" class="item">借贷宝配置</el-checkbox>-->
        <!--        <el-checkbox label="40400" class="item">借贷宝订单管理</el-checkbox>-->
        <!--        <el-checkbox label="40500" class="item">利率管理</el-checkbox>-->
        <!--        <el-checkbox label="40600" class="item">挖矿管理</el-checkbox>-->
        <!--        <el-checkbox label="41200" class="item">活期挖矿</el-checkbox>-->
        <!--        <el-checkbox label="40800" class="item">灵活挖矿</el-checkbox>-->
        <!--        <el-checkbox label="40900" class="item">定期挖矿</el-checkbox>-->
        <!--        <el-checkbox label="41000" class="item">定期挖矿明细</el-checkbox>-->
        <!--        <el-checkbox label="41100" class="item">新币挖矿</el-checkbox>-->
        <!--        <el-checkbox label="103000" class="item">基金管理</el-checkbox>-->
        <!--        <el-checkbox label="108000" class="item">锁仓挖矿配置</el-checkbox>-->
        <!--        <el-checkbox label="108001" class="item">锁仓管理</el-checkbox>-->
        <!--        <el-checkbox label="108002" class="item">解锁管理</el-checkbox>-->
        <!--        <el-checkbox label="108003" class="item">收益发放</el-checkbox>-->
        <!--        <el-checkbox label="108004" class="item">锁仓/解锁统计</el-checkbox>-->

        <div style="height: 10px;"/>
        <el-tag size="small">交易系统</el-tag>
        <div style="height: 10px;"/>
        <!--        <el-checkbox label="50100" class="item-one">C2C订单审批</el-checkbox>-->
        <el-checkbox label="50200" class="item">交易对设置</el-checkbox>
        <el-checkbox label="50300" class="item">交易区设置</el-checkbox>
        <!--        <el-checkbox label="50201" class="item">燃烧代币分红设置</el-checkbox>-->
        <!--        <el-checkbox label="50400" class="item">交易活动设置</el-checkbox>-->
        <!--        <el-checkbox label="50401" class="item">交易活动排行榜</el-checkbox>-->
        <el-checkbox label="50500" class="item">交易对平均买入成本</el-checkbox>
        <el-checkbox label="50501" class="item"
        >交易对订单数,成交信息
        </el-checkbox
        >
        <el-checkbox label="50504" class="item">单个用户成交信息</el-checkbox>
        <el-checkbox label="50502" class="item">持仓数据</el-checkbox>
        <el-checkbox label="50503" class="item">快照持仓数据</el-checkbox>

        <el-checkbox label="50600" class="item">交易异常</el-checkbox>
        <!-- <el-checkbox label="50700" class="item">机器人项目方</el-checkbox> -->
        <!-- <el-checkbox label="50702" class="item">平滑上攻机器人</el-checkbox> -->
        <el-checkbox label="50703" class="item">行情同步策略</el-checkbox>
        <!-- <el-checkbox label="220002" class="item">机器人策略设置</el-checkbox> -->
        <el-checkbox label="50704" class="item">对冲统计</el-checkbox>
        <el-checkbox label="50705" class="item">对冲策略</el-checkbox>
        <el-checkbox label="50706" class="item">中间刷量策略</el-checkbox>
<!--        <el-checkbox label="50730" class="item">虚拟深度</el-checkbox>-->

        <el-checkbox label="50707" class="item">新对冲统计</el-checkbox>
        <el-checkbox label="50708" class="item">新对冲策略</el-checkbox>
        <el-checkbox label="50709" class="item">新对冲策略（读）</el-checkbox>
        <el-checkbox label="50710" class="item">新对冲策略（改）</el-checkbox>
        <el-checkbox label="50711" class="item">新对冲原始记录</el-checkbox>
        <el-checkbox label="50712" class="item">新对冲合并记录</el-checkbox>
        <el-checkbox label="50713" class="item">添加手动对冲记录</el-checkbox>
        <!-- <el-checkbox label="50714" class="item">财务对账</el-checkbox> -->
<!--        <el-checkbox label="50716" class="item">停盘预警</el-checkbox>-->
<!--        <el-checkbox label="50717" class="item">盘口价差预警</el-checkbox>-->
<!--        <el-checkbox label="50718" class="item">价格预警</el-checkbox>-->
<!--        <el-checkbox label="50719" class="item">防板砖预警</el-checkbox>-->
<!--        <el-checkbox label="50720" class="item">深度不足预警</el-checkbox>-->
<!--        <el-checkbox label="50721" class="item">监控警告</el-checkbox>-->
        <el-checkbox label="50722" class="item">盘口做市委托区分</el-checkbox>
        <el-checkbox label="50723" class="item"
        >更新REDIS分布式锁UUID
        </el-checkbox
        >
        <el-checkbox label="10800" class="item">做市商管理</el-checkbox>
        <el-checkbox label="10801" class="item">交易白名单管理</el-checkbox>
        <el-checkbox label="109000" class="item"
        >交易对成本图表分析
        </el-checkbox
        >
        <el-checkbox label="110002" class="item">删除特殊缓存</el-checkbox>
<!--        <el-checkbox label="50202" class="item">交易对提示配置</el-checkbox>-->

        <el-checkbox label="23070101" class="item">委托-委托管理</el-checkbox>
        <el-checkbox label="23070102" class="item">委托-成交明细</el-checkbox>

        <div style="height: 10px;"/>

        <!--        <el-tag size="small">ETP业务系统</el-tag>-->
        <!--        <div style="height: 10px;" />-->
        <!--        <el-checkbox label="110001" class="item-one">ETP合并</el-checkbox>-->
        <!--        <el-checkbox label="110003" class="item">ETP管理</el-checkbox>-->
        <!--        <div style="height: 10px;" />-->

        <!--        <el-tag size="small">OTC业务系统</el-tag>-->
        <!--        <div style="height: 10px;" />-->
        <!--        <el-checkbox label="60100" class="item-one">OTC商户申请</el-checkbox>-->
        <!--        <el-checkbox label="60101" class="item">OTC商户升级</el-checkbox>-->
        <!--        <el-checkbox label="60102" class="item">OTC商户退出</el-checkbox>-->
        <!--        <el-checkbox label="60103" class="item">OTC商户冻结</el-checkbox>-->
        <!--        <el-checkbox label="60104" class="item">OTC商户管理</el-checkbox>-->
        <!--        <el-checkbox label="60200" class="item">OTC收款人审核</el-checkbox>-->
        <!--        <el-checkbox label="60201" class="item">OTC大额广告审核</el-checkbox>-->
        <!--        <el-checkbox label="60202" class="item">OTC订单审核</el-checkbox>-->
        <!--        <el-checkbox label="60203" class="item">OTC订单申诉</el-checkbox>-->
        <!--        <el-checkbox label="60300" class="item">OTC出入金统计</el-checkbox>-->
        <!--        <el-checkbox label="60400" class="item">OTC广告币种配置</el-checkbox>-->
        <!--        <el-checkbox label="60401" class="item">OTC手续费配置</el-checkbox>-->

                <div style="height: 10px;" />
                <el-tag size="small">PORTAL系统</el-tag>
                <div style="height: 10px;" />
                <el-checkbox label="70101" class="item-one">Banner设置新版</el-checkbox>
<!--                <el-checkbox label="70200" class="item">内容设置</el-checkbox>-->
<!--                <el-checkbox label="70300" class="item">邀请海报设置</el-checkbox>-->
<!--                <el-checkbox label="70500" class="item">弹出消息</el-checkbox>-->
<!--                <el-checkbox label="70600" class="item">协议录入</el-checkbox>-->
<!--                <el-checkbox label="70700" class="item">涨幅榜黑名单</el-checkbox>-->
<!--                <el-checkbox label="70701" class="item">人气榜单</el-checkbox>-->
                <el-checkbox label="101008" class="item">app组件设置</el-checkbox>
<!--                <el-checkbox label="101009" class="item">app金刚区设置</el-checkbox>-->
<!--                <el-checkbox label="260001" class="item">app理财配置</el-checkbox>-->
<!--                <el-checkbox label="260000" class="item">板块管理</el-checkbox>-->
<!--                <el-checkbox label="260002" class="item">Focus管理</el-checkbox>-->
<!--                <el-checkbox label="101101" class="item">APP产品类型管理</el-checkbox>-->
<!--                <el-checkbox label="101102" class="item">APP产品精选管理</el-checkbox>-->
<!--                <el-checkbox label="101103" class="item">APP产品推荐管理</el-checkbox>-->
<!--                <el-checkbox label="150001" class="item">社区信息管理</el-checkbox>-->

                <div style="height: 10px;" />
                <el-tag size="small">营销系统</el-tag>
                <div style="height: 10px;" />
                <el-checkbox label="80301" class="item">验证码记录</el-checkbox>
<!--                <el-checkbox label="105000" class="item-one">算力挖矿奖励</el-checkbox>-->
<!--                <el-checkbox label="106000" class="item">币种变基</el-checkbox>-->
<!--                <el-checkbox label="80100" class="item">快讯设置</el-checkbox>-->
<!--                <el-checkbox label="80200" class="item">推送设置</el-checkbox>-->
<!--                <el-checkbox label="80300" class="item">发送邮件</el-checkbox>-->
<!--                <el-checkbox label="80400" class="item">卡券管理</el-checkbox>-->
<!--                <el-checkbox label="80500" class="item">双十一活动</el-checkbox>-->
<!--                <el-checkbox label="80600" class="item">合约争霸</el-checkbox>-->
<!--                <el-checkbox label="80700" class="item">竞猜</el-checkbox>-->
<!--                <el-checkbox label="80800" class="item">社区投票</el-checkbox>-->
<!--                <el-checkbox label="80801" class="item">投票批次设置</el-checkbox>-->
<!--                <el-checkbox label="80802" class="item">投票币种设置</el-checkbox>-->
<!--                <el-checkbox label="80900" class="item">红包配置</el-checkbox>-->
                <el-checkbox label="81000" class="item">批量发送邮件</el-checkbox>
<!--                <el-checkbox label="80302" class="item">邮箱管理</el-checkbox>-->
<!--                <el-checkbox label="82000" class="item">申购管理</el-checkbox>-->
<!--                <el-checkbox label="83000" class="item">活动管理</el-checkbox>-->
<!--                <el-checkbox label="83001" class="item">活动管理-检查、核算</el-checkbox>-->
<!--                <el-checkbox label="84000" class="item">空投转账</el-checkbox>-->
<!--                <el-checkbox label="104000" class="item">竞技场</el-checkbox>-->
<!--                <el-checkbox label="83000" class="item">动物分红记录</el-checkbox>-->
<!--                <el-checkbox label="180001" class="item">NFT管理</el-checkbox>-->
<!--                <el-checkbox label="180002" class="item">盲盒管理</el-checkbox>-->
<!--                <el-checkbox label="180003" class="item">NFT提现管理</el-checkbox>-->

        <div style="height: 10px;"/>
        <el-tag size="small">系统设置</el-tag>
        <div style="height: 10px;"/>
        <el-checkbox label="90100" class="item-one">APP版本设置</el-checkbox>
        <el-checkbox label="90200" class="item">SITE_CONF</el-checkbox>
        <el-checkbox label="90300" class="item">钱包账户设置</el-checkbox>
        <el-checkbox label="90301" class="item">钱包开关</el-checkbox>
        <el-checkbox label="90302" class="item">撤单钱包开关</el-checkbox>
        <el-checkbox label="90303" class="item">手续费设置</el-checkbox>
<!--        <el-checkbox label="90400" class="item">Processor设置</el-checkbox>-->
<!--        <el-checkbox label="90500" class="item">转冷配置与查询</el-checkbox>-->
<!--        <el-checkbox label="90600" class="item">ETH地址nonce管理</el-checkbox>-->
        <div style="height: 10px;"/>
        <el-tag size="small">数据中心</el-tag>
        <div style="height: 10px;"/>
        <el-checkbox label="101000" class="item-one">余额查询</el-checkbox>
        <!--        <el-checkbox label="101001" class="item">活期宝查询</el-checkbox>-->
        <el-checkbox label="101002" class="item">手续费查询</el-checkbox>
        <!--        <el-checkbox label="101003" class="item">合约查询</el-checkbox>-->
        <!--        <el-checkbox label="101004" class="item">部落收益查询</el-checkbox>-->
        <el-checkbox label="101005" class="item">充提统计查询</el-checkbox>
        <!--        <el-checkbox label="101006" class="item">定期宝数据</el-checkbox>-->
        <el-checkbox label="101007" class="item">用户数据</el-checkbox>
<!--        <el-checkbox label="101108" class="item">扫币设置</el-checkbox>-->
<!--        <el-checkbox label="101109" class="item">退币设置</el-checkbox>-->
        <el-checkbox label="101110" class="item">退币审核</el-checkbox>
        <el-checkbox label="100100" class="item">充值提现可视化</el-checkbox>
        <!--        <el-checkbox label="101011" class="item">BKK销毁记录</el-checkbox>-->
        <el-checkbox label="101012" class="item">交易和订单查询</el-checkbox>
        <!--        <el-checkbox label="101013" class="item">staking数据</el-checkbox>-->
<!--        <el-checkbox label="101014" class="item">上币申请查询</el-checkbox>-->
<!--        <el-checkbox label="30503" class="item">充提整体数据</el-checkbox>-->
<!--        <el-checkbox label="101111" class="item">充值退回</el-checkbox>-->

        <!--        <div style="height: 10px;" />-->
        <!--        <el-tag size="small">超级合约业务系统</el-tag>-->
        <!--        <div style="height: 10px;" />-->
        <!--        <el-checkbox label="100000" class="item-one">超级合约配置</el-checkbox>-->
        <!--        <el-checkbox label="100001" class="item">超级合约持仓</el-checkbox>-->
        <!--        <el-checkbox label="100002" class="item"-->
        <!--          >超级合约项目方后台查询</el-checkbox-->
        <!--        >-->
        <!--        <el-checkbox label="100003" class="item"-->
        <!--          >超级合约交易持仓明细下载</el-checkbox-->
        <!--        >-->
        <!--        <el-checkbox label="100004" class="item">超级合约盈亏统计</el-checkbox>-->
        <!--        <el-checkbox label="102000" class="item">代理商后台报表</el-checkbox>-->
        <!--        <el-checkbox label="102001" class="item">代理商项目方</el-checkbox>-->
        <!--        &lt;!&ndash; <el-checkbox label="220003">冰山策略配置</el-checkbox>-->
        <!--                 <el-checkbox label="220004">定时操盘</el-checkbox>-->
        <!--                 <el-checkbox label="220100">机器人项目方管理</el-checkbox>&ndash;&gt;-->

        <!--        <div style="height: 10px;" />-->
        <!--        <el-tag size="small">合约手续费</el-tag>-->
        <!--        <div style="height: 10px;" />-->
        <!--        <el-checkbox label="90501" class="item-one">合约手续费设置</el-checkbox>-->

        <!--        <div style="height: 10px;" />-->
        <!--        <el-tag size="small">币安合约</el-tag>-->
        <!--        <div style="height: 10px;" />-->
        <!--        <el-checkbox label="120001" class="item-one">合约配置</el-checkbox>-->
        <!--        <el-checkbox label="120002" class="item">划转记录</el-checkbox>-->
        <!--        <el-checkbox label="120003" class="item"-->
        <!--          >交易、挂单、订单、强平记录</el-checkbox-->
        <!--        >-->
        <!--        <el-checkbox label="120004" class="item">用户信息查询</el-checkbox>-->
        <!--        <el-checkbox label="120005" class="item">合约统计</el-checkbox>-->

        <!--        <div style="height: 10px;" />-->
        <!--        <el-tag size="small">cms系统</el-tag>-->
        <!--        <div style="height: 10px;" />-->
        <!--        <el-checkbox label="301001" class="item-one">内容管理</el-checkbox>-->
        <!--        <el-checkbox label="301002" class="item">内容管理(简化)</el-checkbox>-->
        <!--        <el-checkbox label="302001" class="item">审核管理</el-checkbox>-->
        <!--        <el-checkbox label="303001" class="item">标签库</el-checkbox>-->
        <!--        <el-checkbox label="304001" class="item">推荐管理</el-checkbox>-->
        <!--        <el-checkbox label="305001" class="item">栏目管理</el-checkbox>-->
        <!--        <el-checkbox label="306001" class="item">统计查询</el-checkbox>-->
        <!--        <el-checkbox label="307001" class="item">币圈信息流</el-checkbox>-->

        <div style="height: 10px;"/>
        <el-tag size="small">数据分析</el-tag>
        <div style="height: 10px;"/>

        <!--        <div style="height: 10px;" />-->
        <!--        <el-tag size="small">策略系统</el-tag>-->
        <!--        <div style="height: 10px;" />-->
        <!--        <el-checkbox label="110000" class="item-one">策略管理</el-checkbox>-->

        <!--        <div style="height: 10px;" />-->
        <!--        <el-tag size="small">代理商管理系统</el-tag>-->
        <!--        <div style="height: 10px;" />-->
        <!--        <el-checkbox label="102002" class="item-one">代理商管理</el-checkbox>-->

        <!--外部项目权限，只需要在此配置，本项目中其他地方不用管-->
        <!--        <div style="height: 10px;" />-->
        <!--        <el-tag size="small">外部项目权限</el-tag>-->
        <!--        <div style="height: 10px;" />-->
        <!--        <el-checkbox label="107000" class="item-one"-->
        <!--          >项目方查询用户持仓</el-checkbox-->
        <!--        >-->
      </el-checkbox-group>

      <div
          style="height: 50px;width: 100%;text-align: center;padding-top: 30px"
      >
        <el-button type="info" @click="closeHandle">取消</el-button>
        <el-button type="primary" @click="submitAuth()">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog
        title="角色修改"
        :visible="showRole"
        @close="closeRole()"
        width="20%"
    >
      <el-form>
        <el-form-item label="用户："
        >{{ roleAlter.realName }}({{ roleAlter.userName }})
        </el-form-item
        >
        <el-form-item label="角色">
          <el-select v-model="roleAlter.role">
            <el-option
                v-for="item in roleType"
                :label="item.desc"
                :key="item.code"
                :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="closeRole()">取消</el-button>
          <el-button type="primary" @click="updateRole()">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import './store';
import {mapActions, mapState} from 'vuex';
import api from './api';

export default {
  name: 'UserRights',
  computed: {
    ...mapState('userAuth', ['adminUserList'])
  },

  data() {
    return {
      dialogShow: false,
      authList: [],
      adminUserId: '',
      username: '',
      role: -1,
      activeName: 'auth', //passphrase
      passphraseConf: {},
      verifyType: '',
      ruleType: [
        {code: 'DATE', desc: '时间类型'},
        {code: 'USERNAME', desc: '用户名类型'},
        {
          code: 'FIXED_CHARACTER',
          desc: '固定字符'
        }
      ],
      verifyTypes: [
        {code: 'VERIFY_RULE_APPROVE', desc: '审核验证规则'},
        {
          code: 'VERIFY_RULE_DEPOSIT',
          desc: '充值验证规则'
        },
        {code: 'VERIFY_RULE_TRANSFER', desc: '转账验证规则'}
      ],
      roleType: [
        {code: 1, desc: '运营'},
        {code: 3, desc: '项目方'},
        {code: 4, desc: '研发'},
        {
          code: 5,
          desc: '审核'
        },
        {code: 6, desc: '代理商'},
        {code: -1, desc: '其它'}
      ],
      roleAlter: {
        id: '',
        role: '',
        userName: '',
        realName: ''
      },
      showRole: false
    };
  },

  created() {
    this.getAdminUserList();
  },

  methods: {
    ...mapActions('userAuth', ['getAdminUserList', 'alterUserAuthType']),

    closeHandle() {
      this.dialogShow = false;
    },

    openDialog(id, authType) {
      if (authType === null || authType === undefined) {
        authType = '';
      }
      this.authList = authType.split(',');
      this.adminUserId = id;
      this.dialogShow = true;
    },

    resetAuth(id, authType) {
      api.resetUserAuth({id: id, authType: authType}).then(() => {
        this.$message.success('权限重置成功');
        this.getAdminUserList();
      });
    },

    submitAuth() {
      let authInfo = '';
      let size = this.authList.length;
      for (let i = 0; i < size; i++) {
        if (i === size - 1) {
          authInfo = authInfo.concat(this.authList[i]);
        } else {
          authInfo = authInfo.concat(this.authList[i]).concat(',');
        }
      }

      this.alterUserAuthType({
        id: this.adminUserId,
        authType: authInfo
      }).then(() => {
        this.$message({message: '修改成功', type: 'success'});
        this.dialogShow = false;
        this.getAdminUserList();
      });
    },

    passphraseSubmit() {
      this.passphraseConf.verifyType = this.verifyType;
      api.buildPassphraseConf(this.passphraseConf).then(() => {
        this.$message.success('更新口令配置成功');
      });
    },

    queryConfig() {
      api
          .queryPassphraseConf({verifyType: this.verifyType})
          .then(response => {
            this.passphraseConf = response.data;
          });
    },

    createAdminUser() {
      api
          .insertAdminUser({username: this.username, role: this.role})
          .then(() => {
            this.$message.success('新增管理端用户成功');
            this.username = '';
            this.getAdminUserList();
          });
    },

    removeAdminUser(id) {
      this.$confirm('是否将该用户从管理端移除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            api.deleteAdminUser({id: id}).then(() => {
              this.$message.success('删除成功');
              this.getAdminUserList();
            });
          })
          .catch(() => {
            this.$message.info('已取消删除');
          });
    },

    syncAdminInfo() {
      api.syncAdminUserInfo().then(() => {
        this.$message.success('同步数据成功');
      });
    },

    parseCodeToDesc(code, infos) {
      for (let index in infos) {
        if (infos[index].code == code) {
          return infos[index].desc;
        }
      }
      return '未知';
    },

    updateRole() {
      api.addAdminUserRole(this.roleAlter).then(() => {
        this.$message.success('操作成功');
        this.getAdminUserList();
        this.closeRole();
      });
    },

    closeRole() {
      this.showRole = false;
    },

    openAlterRole(info) {
      this.roleAlter.id = info.id;
      this.roleAlter.role = info.role;
      this.roleAlter.realName = info.realName;
      this.roleAlter.userName = info.userName;
      this.showRole = true;
    }
  }
};
</script>

<style lang="less" scoped>
.page-container {
  .item-one {
    width: 150px;
    margin-left: 30px;
    margin-bottom: 10px;
    overflow: hidden;
  }

  .item {
    width: 150px;
    margin-bottom: 10px;
    overflow: hidden;
  }
}
</style>
